import { render, staticRenderFns } from "./manualSend.vue?vue&type=template&id=53281296&"
import script from "./manualSend.vue?vue&type=script&lang=js&"
export * from "./manualSend.vue?vue&type=script&lang=js&"
import style0 from "./manualSend.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports